import DiscountModel from "../models/DiscountModel";
import DiscountRepository from "../repositories/DiscountRepository";
import InstallmentService from "./InstallmentService";
import {
  RequiredParamException,
  ImmutableParamException,
} from "../exceptions/InvalidParamException";
import { DiscountLinkedException } from "../exceptions/InstallmentException";

class DiscountService {
  async createDiscount(discount: DiscountModel): Promise<string> {
    this.validateData(discount);
    return DiscountRepository.addDiscountToDataBase(discount);
  }

  async deleteDiscount(discount: DiscountModel): Promise<void> {
    if (discount.quantityLinked) {
      throw new DiscountLinkedException();
    }

    return DiscountRepository.deleteDiscountFromDataBase(
      discount.contractUid,
      discount.uid
    );
  }

  async updateDiscount(
    discount: DiscountModel,
    updatedDiscount: DiscountModel
  ): Promise<void> {
    this.validateUpdatedData(discount, updatedDiscount);
    return DiscountRepository.updateDiscountOnDataBase(
      discount.contractUid,
      discount.uid,
      updatedDiscount
    );
  }

  async updateInstallments(discount: DiscountModel): Promise<void> {
    const installments = discount.installments;
    return DiscountRepository.updateDiscountOnDataBase(
      discount.contractUid,
      discount.uid,
      { installments }
    );
  }

  async updateInstallmentsWithTransaction(
    transaction,
    discount: DiscountModel
  ): Promise<void> {
    const installments = discount.installments;
    return DiscountRepository.updateDiscountOnDataBase(
      discount.contractUid,
      discount.uid,
      { installments },
      transaction
    );
  }

  subscribeDiscountsSnapshot(
    contractUid: string,
    onCreate: (data: DiscountModel[]) => void,
    onChange: (data: DiscountModel[]) => void,
    onRemove: (data: DiscountModel[]) => void
  ) {
    return DiscountRepository.addDiscountsCollectionSnapshot(
      contractUid,
      onCreate,
      onChange,
      onRemove
    );
  }

  validateData(discount: DiscountModel) {
    if (!discount.title) throw new RequiredParamException("title");
    if (!discount.code) throw new RequiredParamException("code");
    if (!discount.date) throw new RequiredParamException("date");

    InstallmentService.validateData(discount);
  }

  validateUpdatedData(discount: DiscountModel, updatedDiscount: DiscountModel) {
    this.validateData(updatedDiscount);

    if (discount.code !== updatedDiscount.code) {
      throw new ImmutableParamException("code");
    }

    InstallmentService.validateUpdatedData(discount, updatedDiscount);
  }
}

export default new DiscountService();
